import Segmented from '@/components/base/Segmented';
import type { CashPeriodMode } from '@/lib/cashSession';

interface PeriodFilterProps {
  mode: CashPeriodMode;
  customDate: string;
  onChangeMode: (mode: CashPeriodMode) => void;
  onChangeCustomDate: (date: string) => void;
}

export default function PeriodFilter({
  mode,
  customDate,
  onChangeMode,
  onChangeCustomDate,
}: PeriodFilterProps) {
  return (
    <div className="flex flex-wrap items-center gap-3">
      <Segmented
        value={mode}
        onChange={(v) => onChangeMode(v as CashPeriodMode)}
        options={[
          { value: 'today', label: 'Hoy' },
          { value: 'yesterday', label: 'Ayer' },
          { value: 'custom', label: 'Fecha personalizada' },
        ]}
      />
      {mode === 'custom' && (
        <input
          type="date"
          value={customDate}
          onChange={(e) => onChangeCustomDate(e.target.value)}
          className="rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-900 focus:outline-none focus:ring-2 focus:ring-primary-400 cursor-pointer"
        />
      )}
    </div>
  );
}